import { Button } from '@material-ui/core';
import PropTypes from 'prop-types';

function StyledButton(props) {
    const styles = {
        'color': props.color == 'primary' ? 'black' : 'white',
        'margin': '10px 0',
        ...props.customstyle,
    };

    return (
        <Button
            style={styles}
            variant="contained"
            {...props}
        />
    );
}


StyledButton.propTypes = {
    children: PropTypes.node.isRequired,
    fullWidth: PropTypes.bool,
    color: PropTypes.oneOf(['primary', 'secondary']),
    onClick: PropTypes.func
};

StyledButton.defaultProps = {
    fullWidth: true,
    color: 'primary'
}

export default StyledButton;